import {Component, Input, OnInit} from '@angular/core';
import {IProduct} from '../../../product/product-models';
import {IShareLinkOptions} from '../../../social/social-models';
import {TranslateService} from '../../../translation/translate.service';
import {BaseComponent} from '../../../base.component';
import {UserService} from '../../../common/user.service';
import {LoggerService} from '../../../common/logger.service';

@Component({
    selector: 'featured-products-row-embed',
    templateUrl: './featured-products-row-embed.component.html',
    styleUrls: ['./featured-products-row.component.scss'],
    standalone: false
})
export class FeaturedProductsRowEmbedComponent extends BaseComponent implements OnInit {
    @Input() products: IProduct[];
    @Input() titleTag: string;
    @Input() shareOptions: IShareLinkOptions;
    @Input() cardRowClass: string;
    @Input() showAiMessage: boolean = false;
    useLocaleOverride: boolean;

    translatedTitle: string;

    constructor(
        private translateService: TranslateService,
        userService: UserService,
        loggerService: LoggerService,
    ) {
        super(userService, loggerService);
    }

    ngOnInit(): void {
        this.translateTitle();
    }

    private translateTitle(): void {
        this.translateService.translate(this.titleTag, this.useLocaleOverride).then((translation: string) => {
            this.translatedTitle = translation;
        });
    }
}
